import NandosI18n from './nandos-i18n'
import * as filters from './filters'

const LibraryModule = {

  _i18n: null,
  _changeLanguage: null,
  _i18nHasMessage: null,

  install(Vue, regionSettings) {
    let plugin = NandosI18n(Vue, regionSettings)
    // Proxy return values [i18n, changeLanguage, i18nHasMessage] to expose them via this export
    Object.entries(plugin).forEach(([key, value]) => this[`_${key}`] = plugin[key])

    // Register filters
    Object.keys(filters)
      .forEach(key => Vue.filter(key, filters[key]))
  },

  get i18n() {
    if(this._i18n == null) return this.notInstalledError()
    return this._i18n
  },

  get changeLanguage() {
    if(this._changeLanguage == null) return this.notInstalledError()
    return this._changeLanguage
  },

  get i18nHasMessage() {
    if(this._i18nHasMessage == null) return this.notInstalledError()
    return this._i18nHasMessage
  },

  t() { // as a convenience, proxy the translate method of the vue-i18n plugin
    let i18n = this.i18n
    return i18n.t(...arguments)
  },

  notInstalledError() {
    throw new Error("[Nandos I18n] Plugin hasn't been installed yet")
  },
}

export default LibraryModule